'use client';

import { intervalToDuration, isAfter, isBefore, setHours, startOfDay } from 'date-fns';
import React, { useEffect, useState } from 'react';
import SmartImage from './SmartImage';

interface DailyDeliveryTimerProps {
  className?: string;
}

const DailyDeliveryTimer: React.FC<DailyDeliveryTimerProps> = ({ className = '' }) => {
  const [timeLeft, setTimeLeft] = useState<{
    hours: number;
    minutes: number;
    seconds: number;
  }>({ hours: 0, minutes: 0, seconds: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  const onVisibilityChange = (visible: boolean) => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('timerVisibilityChange', { detail: { visible } }));
    }
  };

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const todayStart = startOfDay(now);

      const startTime = setHours(todayStart, 19);
      const endTime = setHours(todayStart, 20);

      if (isBefore(now, startTime) || isAfter(now, endTime)) {
        if (isVisible) {
          setIsVisible(false);
          onVisibilityChange(false);
        }
        return;
      }

      if (!isVisible) {
        setIsVisible(true);
        onVisibilityChange(true);
      }

      const duration = intervalToDuration({ start: now, end: endTime });

      setTimeLeft({
        hours: duration.hours || 0,
        minutes: duration.minutes || 0,
        seconds: duration.seconds || 0,
      });
    };

    calculateTimeLeft();
    setIsInitialized(true);

    const interval = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(interval);
  }, [isVisible]);

  if (!isInitialized) {
    return (
      <div
        className={`bg-[#FFDADA] rounded-xl flex flex-row items-center gap-1 px-1 sm:px-2 py-1 whitespace-nowrap flex-shrink-0 ${className}`}
        style={{ visibility: 'hidden' }}
      />
    );
  }

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={`bg-[#FFDADA] rounded-xl flex flex-row items-center gap-1 px-1 sm:px-2 py-1 whitespace-nowrap flex-shrink-0 ${className}`}
    >
      <SmartImage
        src="/ic_chronometer.png"
        width={12}
        height={12}
        className="h-3 sm:h-3 flex-shrink-0 w-auto"
        alt="Bugün Teslimat"
        imageType="icon"
      />
      <div className="font-bold text-[.5rem] sm:text-[.625rem] leading-[1rem] tracking-[-0.005em] text-center align-middle font-fira_mono text-[#2B3280] whitespace-nowrap">
        <span className="hidden sm:inline">Bugün teslimat için son: </span>
        <span className="sm:hidden">Son: </span>
        {timeLeft.minutes.toString().padStart(2, '0')} dak.{' '}
        {timeLeft.seconds.toString().padStart(2, '0')} san.&nbsp;
      </div>
    </div>
  );
};

export default DailyDeliveryTimer;
